const angular = require('angular');
const template = require('./logout-warning.html');

import 'angular-modal-service';
import {LogoutWarningController} from './logout-warning.controller';

export class LogoutWarningModal {

    public static $inject = ['ModalService'];

    constructor(private ModalService) {}

    public show = (time) => {
        this.ModalService.showModal({
            template: template,
            controller: LogoutWarningController,
            controllerAs: 'ctrl',
            inputs: {
                time: time
            }
        });
    };

    /**
     * close all modals opened by the modal service
     */
    public closeAllModals = () => {
        this.ModalService.closeModals();
    }
}

export default angular
    .module('spsng.modals.logout-warning', ['angularModalService'])
    .service('LogoutWarningModal', LogoutWarningModal)
    .name;
